export default __webpack_public_path__ + "static/media/Ate_Original.ccf3c608.jpg";